module.exports = __webpack_public_path__ + "static/media/icon-kitten-title-left.ebe04bd8.svg";